import React, { useEffect, useContext, useState, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  getSystemSettings,
  roundFormatPrice,
  customStyle,
  getTimeDifferenceString,
  getCancelStatusString
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from 'moment';
import Moment from "react-moment";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";

const groupBy = [
  {
    id: 1,
    name: "All"
  },
  {
    id: 2,
    name: "Cancel Items"
  },
  {
    id: 3,
    name: "Edit Items"
  },
  {
    id: 3,
    name: "Refund Items"
  }
];

const CancelItemReport = () => {
  const { t } = useTranslation();
  //getting context values here
  let { loading, setLoading, dataPaginating, generalSettings } = useContext(SettingsContext);
  let { branchForSearch } = useContext(RestaurantContext);
  const { authUserInfo } = useContext(UserContext);

  let [newCancelItemReport, setNewCancelItemReport] = useState(null);

  //all data
  const [reportData, setReportData] = useState(null);

  const componentRef = useRef();
  const componentRefThermalDetail = useRef();
  //settle order
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [reportOption, setReportOption] = useState("excel")
  //useEffect == componentDidMount()
  const [branchSearch, setBranchSearch] = useState(null);

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));
    if (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") {
      setBranchSearch(
        branchForSearch.filter(
          (branch) => branch.id === authUserInfo.details.branch_id
        )
      );
    } else {
      setBranchSearch(branchForSearch);
    }
    setLoading(true);
    setNewCancelItemReport({
      ...newCancelItemReport,
      groupBy: groupBy[0],
    });
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings, branchForSearch]);


  //Print Report
  // const ReportPrint = useRef();

  // const handlePrintBtn = useReactToPrint({
  //   content: () => ReportPrint.current,
  // });

  const handleReportOption = (e) => {
    setReportOption(e.target.value)
  }

  const handleBranch = (branch) => {
    setNewCancelItemReport({
      ...newCancelItemReport,
      branch,
    });
    // setBranch(branch);
  };

  const handleGroupBy = (group) => {
    setNewCancelItemReport({
      ...newCancelItemReport,
      groupBy: group,
    });
    // setBranch(branch);
  };

  const thermalPrintDetail = useReactToPrint({
    content: () => componentRefThermalDetail.current,
    pageStyle: `@page {margin: 5px;}`,
  });

  //get BranchWise reports filter
  const getBranchWiseSelected = () => {
    setReportData(null);
    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !newCancelItemReport?.branch?.[0]?.id
    ) {
      toast.error(`${_t(t("Please select Branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    if (
      // newCancelItemReport?.branch?.id !== null &&
      startDate !== null &&
      endDate !== null
    ) {
      setLoading(true);
      var fromDate = moment(startDate).format("YYYY-MM-DD");
      var toDate = moment(endDate).format("YYYY-MM-DD");

      const url = BASE_URL + "/settings/get-sales-delete_item-report";

      let formData = new FormData();
      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("branch_id", (newCancelItemReport?.branch && newCancelItemReport.branch?.length) ? JSON.stringify(newCancelItemReport?.branch.map((branch) => branch.id)) : "");
      formData.append("group_by", newCancelItemReport?.groupBy?.name ? newCancelItemReport.groupBy.name : "");

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("CancelItemReportResult", res);
          setReportData(res.data);

          setLoading(false);
          console.log("Component ", componentRef);
          setGeneratedReport(true);
          if (reportOption === "print") {
            thermalPrintDetail();
          } else {
            componentRef.current.handleDownload();
          }
          setNewCancelItemReport({
            groupBy: groupBy[0],
            branch: null,
          });
        })
        .catch((error) => {
          setLoading(false);
          if(error.response?.data?.status === 0){
            toast.error(
              `${_t(t(error.response.data?.message))}`,
              {
                position: "bottom-center",
                closeButton: false,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
              }
            );
            return;
          }
        });
    } else {
      toast.error(
        `${_t(t("Please select from date, to date and generate report"))}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  let total_qty = 0;
  let total_price = 0;

  let totalQty = 0;
  let totalPrice = 0;

  return (
    <>
      <Helmet>
        <title>{_t(t("Cancel Item Report (Made/Unmade)"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Cancel Item Report"
        sheet="sheet 1"
        buttonText="Sales Detail"
        ref={componentRef}
      />

      {/* Print Button */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-6 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="23" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Cancel Item Report (Made/Unmade)
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Group"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("S/L"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Date"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Branch"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Token"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Cust Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Menu"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Order Type"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Party Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Food Group"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Food Item"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Variation"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Reason"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Order Status"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Punch Time"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Cancel Time"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Time Diff"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Cancel Priority"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Status"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Waiter Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Qty"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Price"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("User Name"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {reportData &&
                                  Object.keys(reportData).map((group)=>{
                                    return (
                                      <>
                                        <tr>
                                          <th>
                                            {group}
                                          </th>
                                        </tr>
                                        {reportData[group]?.length && reportData[group].map((item, i) => {
                                          total_qty += parseFloat(item.quantity);
                                          total_price += parseFloat(item.price);
                                          return (
                                            <tr key={i}>
                                              <td></td>
                                              <td>
                                                {i + 1}
                                              </td>
                                              <td>
                                                <Moment format="LL">
                                                  {item.order_date}
                                                </Moment>
                                              </td>
                                              <td>
                                                {item.branch_name}
                                              </td>
                                              <td>
                                                {item.token.id}
                                              </td>
                                              <td>
                                                {item.customer_name}
                                              </td>
                                              <td>
                                                {item.dept_tag_name}
                                              </td>
                                              <td>
                                                {item.order_type_name}
                                              </td>
                                              <td>
                                                {item.party_name}
                                              </td>
                                              <td>
                                                {item.food_group}
                                              </td>
                                              <td>
                                                {item.food_item}
                                              </td>
                                              <td>
                                                {item.variation}
                                              </td>
                                              <td>
                                                {item.reason}
                                              </td>
                                              <td>
                                                {item.order_type}
                                              </td>
                                              <td>
                                                <Moment format="hh:mm A">
                                                  {item.created_at}
                                                </Moment>
                                              </td>
                                              <td>
                                                <Moment format="hh:mm A">
                                                  {item.updated_at}
                                                </Moment>
                                              </td>
                                              <td>
                                                {getTimeDifferenceString(item.created_at, item.updated_at)}
                                              </td>
                                              <td>
                                                <strong>
                                                  {getCancelStatusString(item.created_at, item.updated_at)}
                                                </strong>
                                              </td>
                                              <td>
                                                {item.status}
                                              </td>
                                              <td>
                                                {item.waiter_name}
                                              </td>
                                              <td>
                                                {item.quantity}
                                              </td>
                                              <td>
                                                {item.price}
                                              </td>
                                              <td>
                                                {item.user_name}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </>
                                    )
                                  })
                                }
                                <tr></tr>
                                <tr>
                                  <th
                                    colspan="19"
                                    style={{ border: "0px" }}
                                  ></th>
                                  <th>
                                    Total
                                  </th>
                                  <td>
                                    {formatPrice(total_qty)}
                                  </td>
                                  <td>
                                    <strong>
                                      {formatPrice(total_price)}
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="7"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Button thermal */}
      <div className="d-none">
        <div ref={componentRefThermalDetail}>
          <div className="fk-print">
            <div className="container-fuild">
              <div className="row">
                <div className="col-12">
                  {reportData !== null && reportData &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">

                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="13" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Cancel Item Report (Made/Unmade)
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th className="border border-1 table_child_total">
                                    {_t(t("Group Name"))}
                                  </th>
                                  <th className="border border-1 table_child_time"
                                  >
                                    {_t(t("Order Date"))}
                                  </th>
                                  <th className="border border-1 table_child_token"
                                  >
                                    {_t(t("Token"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Branch Name"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Custome Name"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Menu"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Order Type"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Party Name"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Food Item"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Variation"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Order Status"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Status"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Qty"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Price"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("User Name"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {reportData &&
                                  Object.keys(reportData).map((group)=>{
                                    return(
                                      <>
                                        <tr>
                                          <td>
                                            {group}
                                          </td>
                                        </tr>
                                        {reportData[group]?.length && reportData[group].map((item, i) => {
                                          totalQty += parseFloat(item.quantity);
                                          totalPrice += parseFloat(item.price);
                                          return (
                                            <tr key={i}>
                                              <td></td>
                                              <td>
                                                <Moment format="LL">
                                                  {item.order_date}
                                                </Moment>
                                              </td>
                                              <td>
                                                {item.token.id}
                                              </td>
                                              <td>
                                                {item.branch_name}
                                              </td>
                                              <td>
                                                {item.customer_name}
                                              </td>
                                              <td>
                                                {item.dept_tag_name}
                                              </td>
                                              <td>
                                                {item.order_type_name}
                                              </td>
                                              <td>
                                                {item.party_name}
                                              </td>
                                              <td>
                                                {item.food_item}
                                              </td>
                                              <td>
                                                {item.variation}
                                              </td>
                                              <td>
                                                {item.order_type}
                                              </td>
                                              <td>
                                                {item.status}
                                              </td>
                                              <td>
                                                {item.quantity}
                                              </td>
                                              <td>
                                                {item.price}
                                              </td>
                                              <td>
                                                {item.user_name}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </>
                                    )
                                  })
                                }
                                <tr></tr>
                                <tr>
                                  <th
                                    colspan="11"
                                    style={{ border: "0px" }}
                                  ></th>
                                  <th>
                                    Total
                                  </th>
                                  <td>
                                    {formatPrice(totalQty)}
                                  </td>
                                  <td>
                                    {formatPrice(totalPrice)}
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="13"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating} />
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {/* {loading === true ? (
                      tableLoading()
                    ) : ( */}
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-6 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Cancel Item Report (Made/Unmade)"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-6 d-flex justify-content-end p-0">
                          <ReportTypeOptions
                            selectedOption={reportOption}
                            onChange={handleReportOption}
                          />
                        </div>
                      </div>
                      <div className="row gx-2 mt-2">
                        <div className="col-2 d-md-block">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2 t-mb-15 mb-md-0"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>
                        <div className="col-2 t-mb-15 mb-md-0">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>
                        <div className="col-3">
                          <Select
                            options={branchSearch ? branchSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={newCancelItemReport?.branch}
                            classNamePrefix="select"
                            className="sm-text"
                            isMulti
                            styles={customStyle}
                            onChange={handleBranch}
                            isClearable
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>
                        <div className="col-2">
                          <Select
                            options={groupBy && groupBy}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={newCancelItemReport?.groupBy}
                            classNamePrefix="select"
                            styles={customStyle}
                            className="sm-text "
                            onChange={handleGroupBy}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a group")) + ".."}
                          />
                        </div>
                        <div className="col-3 t-mb-15 mb-md-0">
                          {/* Action Button */}
                          <button
                            className="btn btn-block btn-primary text-uppercase sm-text py-2 rounded"
                            onClick={(e) => getBranchWiseSelected(e)}
                          >
                            Print Cancel Item Report
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default CancelItemReport;
